module.exports = __webpack_public_path__ + "img/4.Feeding & Watering Supplies.9a22786c.jpg";